// Components imports
import { getCurrencySymbol } from "./helpers";
//import SearchBar from "./components/SearchBar";
//import StandAlone from "./components/StandAlone";
//import CardProduct from "./components/CardProduct";
//import IndpNewTask from "./components/IndpNewTask";
//import SearchBanner from "./components/SearchBanner";
// import ResultsRenderer from "./components/ResultsRenderer";
//import IndpCommentComponent from "./components/IndpCommentComponent";
//import AppSearchBar from "./components/AppSearchBar";

// React instances
global.React = require("react");
global.ReactDOM = require("react-dom");
global.ReactDOMServer = require("react-dom/server");

// Components
// global.SearchBar = SearchBar;
// global.StandAlone = StandAlone;
// global.CardProduct = CardProduct;
// global.IndpNewTask = IndpNewTask;
// global.SearchBanner = SearchBanner;
// global.ResultsRenderer = ResultsRenderer;
// global.IndpCommentComponent = IndpCommentComponent;
//global.AppSearchBar = AppSearchBar;